import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PlayerListItem } from '../../../model/player';

@Component({
  selector: 'app-player-list-card',
  templateUrl: './player-list-card.component.html',
  styleUrls: ['./player-list-card.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class PlayerCardListComponent implements AfterViewInit {

  @ViewChild('playerNameContainer', { read: ElementRef }) playerNameContainer: ElementRef;
  @ViewChild('playerNameText', { read: ElementRef }) playerNameText: ElementRef;

  @Input() playerListItem: PlayerListItem;
  @Input() isSelected: boolean = false;

  @Output() playerClick: EventEmitter<PlayerListItem> = new EventEmitter<PlayerListItem>();

  protected isActiveCarousel: boolean = false;

  constructor() { }

  ngAfterViewInit() {
    this.updateIsActiveCarousel();
  }

  @HostListener('window:resize')
  onResize() {
    if (this.isSelected) {
      this.scrollIntoView();
    }
  }

  onPlayerClick() {
    // Emit the player click event
    this.playerClick.emit(this.playerListItem);
    // Scroll to the selected player
    this.scrollIntoView();
  }

  private scrollIntoView() {
    // Scroll to the selected player
    this.playerNameContainer.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    });
  }

  private async updateIsActiveCarousel(): Promise<void> {

    const checkDelay = 50;

    while (!this.playerNameContainer || !this.playerNameText) {
      await new Promise(resolve => setTimeout(resolve, checkDelay));
    }

    for (let i = 0; i < 10; i++) {
      await new Promise(resolve => setTimeout(resolve, checkDelay));
      const textSize = this.playerNameText.nativeElement.offsetWidth;
      const containerSize = this.playerNameContainer.nativeElement.offsetWidth;
      this.isActiveCarousel = textSize >= containerSize;
    }
  }

}
